<template>
    <div>
        <aside class="no-drag" v-click-outside="onClickOutside">
            <div>
                <ul>
                    <li class="waves-effect waves-dark" style="opacity: 1">
                        <img style="width: 50px;vertical-align: text-top;"
                             src="@/assets/login/title.png" @click="clickProfile()">
                    </li>

                    <li class="waves-effect waves-dark" >
                        <div class="item" @click="clickWork()">
                            <img src="../assets/img/leftbar/提案审批.png">
                            <span>工作任务</span>
                        </div>
                    </li>

                    <li class="waves-effect waves-dark" >

                        <div class="item" @click="handleExtend('应用管理',appliances)">
                            <img src="../assets/img/leftbar/应用管理.png">
                            <span>应用管理</span>
                        </div>

                    </li>

                    <li class="waves-effect waves-dark" >
                        <div class="item" @click="handleExtend('课表',timetables)">
                            <img src="../assets/img/leftbar/课表.png">
                            <span>课表</span>
                        </div>
                    </li>

                    <li class="waves-effect waves-dark" >

                        <div class="item" @click="handleExtend('数据看板',anlys)">
                            <img src="../assets/img/leftbar/数据看板.png">
                            <span>数据看板</span>
                        </div>

                    </li>
                    <li class="waves-effect waves-dark" >

                        <div class="item" @click="handleExtend('仓库',warehouse)">
                            <img src="../assets/img/leftbar/功能定义.png">
                            <span>仓库管理</span>
                        </div>

                    </li>

                    <li class="waves-effect waves-dark">

                        <div class="item" @click="handleExtend('设置',settings)">
                            <img src="../assets/img/leftbar/设置.png">
                            <span>设置</span>
                        </div>
                    </li>

                    <!--<li class="waves-effect waves-dark" @click="clickContact()">-->
                    <!--<el-tooltip class="item" effect="dark" content="通讯录" placement="right">-->

                    <!--<img src="../assets/img/leftbar/通讯录.png">-->
                    <!--<span>通讯录</span>-->
                    <!--</el-tooltip>-->
                    <!--</li>-->

                    <!--<li class="waves-effect waves-dark">-->
                    <!--<el-tooltip class="item" effect="dark" content="消息通知" placement="right">-->

                    <!--<img src="../assets/img/leftbar/消息通知.png">-->
                    <!--<span>消息通知</span>-->
                    <!--</el-tooltip>-->

                    <!--</li>-->
                    <!--<li class="waves-effect waves-dark"  @click="clickWeChat()">-->
                    <!--<el-tooltip class="item" effect="dark" content="微信公众号" placement="right">-->

                    <!--<img src="../assets/img/leftbar/企业微信.png">-->
                    <!--<span>微信公众号</span>-->
                    <!--</el-tooltip>-->
                    <!--</li>-->
                </ul>
            </div>



        </aside>
        <div class="extend" :class="{'exActive':extend.status}">
            <ul>
                <li class="title">{{extend.title}}</li>
                <li v-for="item in extend.items" v-if="powers.includes(item.power)" :key="item.title" >
                    <a class="waves-effect waves-dark" @click="handleGo(item)">
                        <span>{{item.title}}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>

</template>

<script>
    import * as vClickOutside from 'v-click-outside-x'

    export default {
        name: "Sidebar",
        directives: {
            clickOutside: vClickOutside.directive
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            }
        },
        data() {
            return {
                timetables: [
                    {"title": "每日课表", "router": "/timetable/daily", "power": 53},
                    {"title": "学期课表", "router": "/timetable/semester", "power": 54},
                    {"title": "教师课表", "router": "/timetable/teacher", "power": 54},
                    {"title": "签到课表", "router": "/timetable/signLog", "power": 55},
                ],
                anlys: [
                    {"title": "同学科续班数据", "router": "/anlyDashboard/subjectRenewal", "power": 75},
                    {"title": "学生续班数据", "router": "/anlyDashboard/StudentRenewal", "power": 111},
                    {"title": "班主任续班数据", "router": "/anlyDashboard/headTeacherRenewal", "power": 101},
                    {"title": "机构续班数据", "router": "/anlyDashboard/organizationRenewal", "power": 109},
                    {"title": "余课学生数据", "router": "/anlyDashboard/crunkStudent", "power": 110},
                    {"title": "合同列表", "router": "/anlyDashboard/invoice", "power": 81},
                    {"title": "回访一周数据", "router": "/anlyDashboard/returnVisitWeek", "power": 92},
                    {"title": "财务一合同数据", "router": "/anlyDashboard/financialInvoice", "power": 152},
                    {"title": "财务一班级数据", "router": "/anlyDashboard/financialClass", "power": 152},
                    {"title": "财务一商店数据", "router": "/anlyDashboard/financialShop", "power": 152},
                    {"title": "各时段学生数据", "router": "/anlyDashboard/templateTimeStudent", "power": 157},
                    {"title": "每日学生数据", "router": "/anlyDashboard/dailyStudent", "power": 167},
                    {"title": "新班主任续班数据", "router": "/anlyDashboard/newHeadTeacherRenewal", "power": 101},
                    {"title": "老师/学科续班数据", "router": "/anlyDashboard/continueToClassRenewal", "power": 158},
                    {"title": "学生数据", "router": "/anlyDashboard/semesterStudentRenewal", "power": 159},
                    {"title": "优惠券使用数据", "router": "/anlyDashboard/discountTypeRenewal", "power": 160},
                    {"title": "教师工作量数据", "router": "/anlyDashboard/teacherWorkloadRenewal", "power": 161},
                    {"title": "线上余课数据", "router": "/anlyDashboard/onlineStudentClassHour", "power": 163},
                    {"title": "收费追踪数据", "router": "/anlyDashboard/CartTrackingRenewal", "power": 170},

                ],
                appliances: [
                    {"title": "新生报名", "router": "/student/register", "power": 1},
                    {"title": "回访列表", "router": "/returnVisit/list", "power": 19},
                    {"title": "学生列表", "router": "/student/list", "power": 2},
                    {"title": "班主任额度", "router": "/headTeacher/limit", "power": 123},
                    {"title": "成员列表", "router": "/employee/list", "power": 24},
                    {"title": "教师列表", "router": "/teacher/list", "power": 64},
                    {"title": "考试列表", "router": "/exam/list", "power": 82},
                    {"title": "推荐人名单", "router": "/referrer/list", "power": 89},
                    {"title": "学生通知列表", "router": "/student/CourseNotify/list", "power": 2},
                    {"title": "退款处理", "router": "/refund/list", "power": 141},
                    {"title": "上下课通知", "router": "/class/emailSending", "power": 166},
                    // {"title": "押金管理", "router": "/student/deposit/list", "power": 172},
                    {"title": "学生管理", "router": "/student/management/list", "power": 173},
                    // {"title": "教案管理", "router": "/teacherPlan/list", "power": 1},
                    {"title": "套餐管理", "router": "/classPackage/list", "power": 176},
                    {"title": "续班列表", "router": "/renew/list", "power": 179},
                    {"title": "组团列表", "router": "/team/list", "power": 182},
                    {"title": "定金列表", "router": "/earnest/list", "power": 184}
                    // {"title": "发送通知", "router": "/message/send", "power": 0},
                ],
                warehouse: [
                    // {"title": "初始化", "router": "/setting/init","power":1},
                    {"title": "租赁库存清单", "router": "/warehouse/leaseInventoryList", "power": 177},
                    {"title": "出售库存清单", "router": "/warehouse/sellInventoryList", "power": 177},
                    {"title": "出租中清单", "router": "/warehouse/rentingList", "power": 177},
                    {"title": "已出售清单", "router": "/warehouse/sellList", "power": 177},
                    {"title": "老师分配清单", "router": "/warehouse/teacherDistribution", "power": 177},
                    {"title": "押金列表", "router": "/warehouse/depositList", "power": 177},
                    {"title": "仓库", "router": "/warehouse/storeList", "power": 177},
                ],
                settings: [
                    // {"title": "初始化", "router": "/setting/init","power":1},
                    {"title": "学期管理", "router": "/semester/list", "power": 56},
                    {"title": "教室管理", "router": "/classroom", "power": 61},
                    {"title": "权限分配", "router": "/authority/list", "power": 26},
                    {"title": "优惠模板", "router": "/discountType", "power": 103},
                    {"title": "课时管理", "router": "/classHour", "power": 153},
                    {"title": "商店管理", "router": "/shop", "power": 154},
                    {"title": "工作日设置", "router": "/workSchedule", "power": 155},
                ],
                extend: {
                    status: false,
                    items: [],
                    title: ""
                }
            }
        },
        methods: {
            clickProfile(){
                this.$Win.openModal('Dialog_SelfSetting', 400, 300, '个人信息', {});
            },
            handleExtend(title, item) {
                this.extend.title=title;
                this.extend.items=item;
                this.extend.status=true;

            },
            clickWork() {
                this.router.push({path: '/'});
                this.extend.status = false
            },
            handleGo(item) {
                this.$store.dispatch('addView', {
                    'title': item.title,
                    'type': 'info',
                    'path': item.router,
                    'closable': true
                });
                this.router.push({path: item.router});
                this.extend.status = false
            },
            onClickOutside() {
                this.extend.status = false;
            }
        }
    }
</script>

<style scoped lang="scss">

    aside {
        position: fixed;
        width: 59px;
        padding: 20px 10px;
        height: 100%;
        top: 0;
        background: #161931;
        overflow: hidden;
        z-index: 2001;

        ul {
            display: flex;
            flex-direction: column;
            margin: 0;
            padding: 0;

            li {

                &:hover {
                    cursor: pointer;
                    opacity: 1;
                }

                opacity: 0.9;
                height: 65px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                list-style: none;
                font-size: 13px;

                img {
                    width: 25px;
                    margin: 0 13px;
                }

                span {
                    font-size: 12px;
                    /*display: none;*/
                    color: #fff
                }
            }
        }

    }

    .extend {
        .title {
            opacity: 1;
            color: #fff;
            font-size: 16px;
        }

        &.exActive {
            display: block;
        }

        display: none;
        position: fixed;

        top: 0;
        left: 59px;
        background: rgb(35, 39, 72);
        height: 100%;
        width: 120px;
        padding: 20px 0;
        z-index: 9999;

        ul {
            display: flex;
            flex-direction: column;
            margin: 0;
            padding: 0;

            li {
                &:hover {
                    cursor: pointer;
                    opacity: 0.9;
                }

                text-align: left;
                opacity: 0.7;
                height: 30px;
                display: flex;
                justify-content: center;
                align-items: center;
                list-style: none;
                font-size: 13px;

                span {
                    font-size: 12px;
                    display: block;
                    color: #fff
                }
            }
        }
    }

</style>
